import styled from '@emotion/styled';
import React, { MouseEventHandler, useCallback } from 'react';
import { MoreMenuButton } from 'ui-components/common/MoreMenuButton';
import { MenuItem, MoreMenuList } from 'ui-components/common/MoreMenuList';
import { useMenuRef } from 'ui-hooks/useMenuRef';
import { css } from '@emotion/react';

interface MoreMenuProps {
  className?: string;
  vertical?: boolean;
  color?: string;
  menu: MenuItem[];
  disabled?: boolean;
}

export const MoreMenu = ({ className, vertical, color, menu, disabled = false }: MoreMenuProps) => {
  const { ref, isOpen, setOpen } = useMenuRef<HTMLDivElement>();

  const handleClick: MouseEventHandler<HTMLDivElement> = useCallback(
    e => {
      if (disabled) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      setOpen(prev => !prev);
    },
    [disabled, setOpen],
  );

  return (
    <StyledContainer ref={ref} className={className} onClick={handleClick} disabled={disabled}>
      <StyledMoreMenuButton vertical={vertical} color={color} isOpen={isOpen} />
      {isOpen && <MoreMenuList menu={menu} />}
    </StyledContainer>
  );
};

const StyledContainer = styled.div(
  ({ disabled }: { disabled: boolean }) => css`
    position: relative;
    width: 20px;
    height: 20px;

    opacity: ${disabled ? 0.3 : 1};
    pointer-events: ${disabled ? 'none' : 'auto'};
  `,
);

const StyledMoreMenuButton = styled(MoreMenuButton)`
  width: 100%;
  height: 100%;
`;
